import { render } from "./TrainingNpecComponent.vue?vue&type=template&id=59984b20&scoped=true"
import script from "./TrainingNpecComponent.vue?vue&type=script&lang=js"
export * from "./TrainingNpecComponent.vue?vue&type=script&lang=js"

import "./TrainingNpecComponent.vue?vue&type=style&index=0&id=59984b20&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59984b20"]])

export default __exports__